import React from 'react'

export default function Done() {
  return (
   <section className="done">
    <img src="/image/done.png" alt="" />
    <h2>Your Order Is Completed! </h2>
    <p><span> Thank you for your order! Your order is being processed and will be completed within 3-6
hours. You will receive an email confirmation when your order is completed.
Thank you for your order! Your order is being processed and will be completed within 3-6
hours. You will receive an email confirmation when your order is completed.
</span>
</p>
<button className='btn1'>Continue Shopping</button>
   </section>
  )
}
